<script>
import Translatable from '@src/mixins/translatable.js'

export default {
  props: {
    area: {
      type: Object
    },
  },
  mixins: [
    Translatable
  ],
  data() {
    return {
      isFooterExpanded: false
    }
  },
  computed: {
    backgroundImage() {
      const img = this.area.images ? this.area.images[0] : ''
      return {
        backgroundImage: `url(${process.env.VUE_APP_STATIC_URL}small_${img})`
      }
    },
  },
  methods: {
    toggle() {
      this.isFooterExpanded = !this.isFooterExpanded
    },
  }
}
</script>

<template>
  <router-link :to="{ name: 'district', params: { slug: area.slug } }" class="link">
    <div class="card-container" :style="backgroundImage">
      <div
        ref="footer"
        :class="isFooterExpanded ? 'card-footer-expanded' : 'card-footer'"
        @mouseenter="toggle"
        @mouseleave="toggle"
      >
        <div class="card-footer-content">
          <p class="attraction-title">
            {{ getTranslatedContent('title', area.content) }}
          </p>
          <p
            v-if="isFooterExpanded"
            v-html="getTranslatedContent('subtitle', area.content)"
            class="attraction-subtitle"
            >
          </p>
        </div>
      </div>
    </div>
  </router-link>
</template>

<style lang="scss" scoped>
@import '@design';

.link {
  text-decoration: none;
}

.card-container {
  height: 204px;
  width: 270px;
  background: $dark-gray;
  position: relative;
  border-radius: 10px;
  margin: 0 20px 20px 0;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}

.card-footer-mixin {
  position: absolute;
  display: flex;
  align-items: center;
  text-align: center;
  bottom: 0;
  width: 100%;
  background: rgba(37, 44, 62, 0.6);
  border-radius: 0 0 10px 10px;
}

.card-footer-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  padding: 0 20px;
}

.card-footer {
  @extend .card-footer-mixin;
  height: 60px;
}

.card-footer-expanded {
  @extend .card-footer-mixin;
  height: 100px;
}

.attraction-title {
  font-family: Open Sans Semibold, sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 18px;
  text-transform: uppercase;
  color: $white;
  margin-bottom: 5px;
}

.attraction-subtitle {
  width: 100%;
  height: 48px;
  font-family: Open Sans, sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 16px;
  color: $white;
}

@media only screen and (min-width: $mobile-screen-width) and (max-width: $container-width-xs) {
  .card-container {
    height: 230px;
    width: 100%;
    border-radius: 0;
    margin: 2.5px 0;
  }

  .card-footer, .link {
    border-radius: 0;
    width: 100%;
  }

  .card-footer-mixin, .card-container {
    border-radius: 0;
  }
}
</style>
